import { ReactElement } from 'react';

import { AppointmentEncounterMode } from '@dreryk/egabinet-appointment-frontend-api';

import { IconFillColor, IconSize, IconWrapper, VideoConsultationIcon } from '@dreryk/react-components';

type AppointmentsTimetableEventVideoConsultationIconProps = {
   encounterMode: AppointmentEncounterMode;
};

export const AppointmentsTimetableEventVideoConsultationIcon = (
   props: AppointmentsTimetableEventVideoConsultationIconProps
): ReactElement | null => {
   if (props.encounterMode !== 'VIDEO_CONSULTATION') {
      return null;
   }

   return (
      <IconWrapper testId={'videoConsultation'} fillColor={IconFillColor.PRIMARY} size={IconSize.SMALLEST}>
         <VideoConsultationIcon />
      </IconWrapper>
   );
};
